import React, { Component } from 'react'
import Swiper from 'react-slider-swiper'
import Dotdotdot from 'react-dotdotdot'

import 'react-slider-swiper/src/styles/css/swiper.css'
import './styles/PopoverStyles.css'

class Popover extends Component {

    constructor(props) {
        super(props)

        this.state = {
            isVisible: false,
            object: null
        }
    }

    show(object) {
        this.setState({
            object: object,
            isVisible: true
        })
    }

    hide() {
        this.setState({
            isVisible: false
        })
    }

    _renderSlides() {
        const photos = this.state.object.photo

        if (photos && photos.length) {
            return photos.map((item, i) => {
                return (
                    <div className="PopoverSlide" key={`PopoverSlide${i}`} style={{ backgroundImage: `url("${item.thumbUrl?item.thumbUrl:item.url}")` }}>
                        <div className="PopoverSlideOverlay">

                        </div>
                    </div>
                )
            })
        }

        return null

    }

    renderTags(tags) {
        if (!tags) return

        const tagsArr = []

        for (let key in tags) {
            tagsArr.push(tags[key])
        }

        return tagsArr.map((item, i) => {
            return (
                <div className="PopoverTag" key={`PopoverTag${i}`}>
                    {item.title}
                </div>
            )
        })
    }

    render() {

        const object = this.state.object

        if (this.state.isVisible) {
            return (
                <div className={'PopoverWrapper'} >
                    <div className="PopoverOverlay" onClick={this.hide.bind(this)}></div>
                        <div className="PopoverGutter" >
                        <div className="ClosePopover" onClick={this.hide.bind(this)} />
                            <div className="columns is-multiline PopoverInner" >
                                          
                                <div className="column is-12 PopoverContentWrapper">

                                    <Swiper
                                        pagination={'.PopoverDots'}
                                        paginationClickable={true}
                                        nextButton={'.PopoverRightArrow'}
                                        prevButton={'.PopoverLeftArrow'}
                                        spaceBetween={0}
                                        slidesPerView={1}
                                        loop={true}
                                    >
                                        {this.state.object ? this._renderSlides() : null}
                                    </Swiper>
                                </div>

                                <div className="NameAddress column is-10">
                                    <div className="columns is-multiline">
                                        <div className="PopoverSlideTitleWrapper">{object.title}</div>
                                        <div className="PopoverSlidePlaceWrapper">{object.address}</div>
                                    </div>
                                </div>

                                <div className="PopoverDescrWrapper column is-10">
                                    <Dotdotdot clamp={5}>
                                        {object.descr}
                                    </Dotdotdot>
                                </div>

                                <div className="PopoverTagsWrapper column is-10">
                                    {this.renderTags(object.tags)}
                                </div>

                        </div>
                    </div>
                </div>
            )
        } else {
            return null
        }

    }
}

export default Popover


// WEBPACK FOOTER //
// ./src/Components/Popover/index.js